import { _ as __rest, a as __assign } from './tslib.es6-ff7ae7b8.js';
import * as React from 'react';
import React__default, { useState, useRef, useEffect } from 'react';
import { C as CloseIcon } from './CloseIcon-ee1d8a9a.js';
import './index-b0444989.js';
import './countries-0aa398a1.js';
import { P as Popover } from './index-930383e2.js';
import { TextInput } from './es/components/TextInput.js';

var SearchIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5947 3.44445C7.54465 3.44445 4.2614 6.72769 4.2614 10.7778C4.2614 14.8279 7.54465 18.1111 11.5947 18.1111C15.6448 18.1111 18.9281 14.8279 18.9281 10.7778C18.9281 6.72769 15.6448 3.44445 11.5947 3.44445ZM1.81696 10.7778C1.81696 5.37766 6.19462 1 11.5947 1C16.9949 1 21.3725 5.37766 21.3725 10.7778C21.3725 16.1779 16.9949 20.5556 11.5947 20.5556C6.19462 20.5556 1.81696 16.1779 1.81696 10.7778Z", fill: fillColor }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.7805 15.9636C17.2578 15.4863 18.0317 15.4863 18.509 15.9636L23.459 20.9136C23.9363 21.3909 23.9363 22.1648 23.459 22.6421C22.9817 23.1194 22.2078 23.1194 21.7305 22.6421L16.7805 17.6921C16.3032 17.2148 16.3032 16.4409 16.7805 15.9636Z", fill: fillColor })));
};

function useDebounce(value, delay) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var timerRef = useRef(null);
    var cancel = function () {
        if (timerRef === null || timerRef === void 0 ? void 0 : timerRef.current) {
            clearTimeout(timerRef.current);
        }
    };
    var reset = function (value) {
        setDebouncedValue(value);
        cancel();
    };
    useEffect(function () {
        if (timerRef) {
            timerRef.current = setTimeout(function () { return setDebouncedValue(value); }, delay !== null && delay !== void 0 ? delay : 500);
        }
        return function () { return cancel(); };
    }, [value, delay]);
    return {
        value: debouncedValue,
        reset: reset,
    };
}

var styles = {"popover":"SearchInput_popover_259a354c","clearButton":"SearchInput_clearButton_259a354c"};

var WithPopover = function (_a) {
    var showPopover = _a.showPopover, popoverContent = _a.popoverContent, children = _a.children, ariaLabel = _a.ariaLabel;
    return (React__default.createElement(Popover, { isOpen: showPopover, placement: ["bottom", "top"], size: "parent", className: styles.popover, content: React__default.createElement(React__default.Fragment, null, popoverContent), "aria-label": ariaLabel }, children));
};
var SearchInput = React__default.forwardRef(function SearchInput(props, ref) {
    var _a = props.debounceDelay, debounceDelay = _a === void 0 ? 500 : _a, onSearchQueryChange = props.onSearchQueryChange, popoverContent = props.popoverContent, label = props.label, showLabel = props.showLabel, id = props.id, _b = props["data-testid"], testId = _b === void 0 ? "search-input" : _b; props["aria-label"]; var popoverLabel = props.popoverLabel, _c = props.preventDefault, preventDefault = _c === void 0 ? false : _c, otherProps = __rest(props, ["debounceDelay", "onSearchQueryChange", "popoverContent", "label", "showLabel", "id", "data-testid", "aria-label", "popoverLabel", "preventDefault"]);
    var _d = useState(""), value = _d[0], setValue = _d[1];
    var _e = useState(false), showPopover = _e[0], setShowPopover = _e[1];
    var debounced = useDebounce(value, debounceDelay);
    useEffect(function () {
        onSearchQueryChange === null || onSearchQueryChange === void 0 ? void 0 : onSearchQueryChange(debounced.value);
    }, [debounced.value, onSearchQueryChange]);
    var handleChange = function (e) {
        setValue(e.target.value);
    };
    var onClearInput = function () {
        // Reset value immediately without waiting for debounce
        setValue("");
        debounced.reset("");
    };
    var iconRight = (value === null || value === void 0 ? void 0 : value.length) > 0
        ? {
            icon: React__default.createElement(CloseIcon, null),
            label: "Clear search",
            onClick: onClearInput,
            className: styles.clearButton,
        }
        : undefined;
    var iconLeft = {
        icon: React__default.createElement(SearchIcon, null),
    };
    var textInputProps = __assign({ ref: ref, label: label, id: id, showLabel: showLabel, autoComplete: "off", "data-testid": testId, onChange: handleChange, onFocus: function () { return setShowPopover(true); }, onBlur: function () { return setShowPopover(false); }, value: value, iconLeft: iconLeft, iconRight: iconRight }, otherProps);
    var preventDefaultBehaviour = function (e) {
        e.preventDefault();
    };
    var onSubmit = preventDefault ? preventDefaultBehaviour : undefined;
    if (popoverContent && popoverLabel) {
        return (React__default.createElement(WithPopover, { showPopover: showPopover, popoverContent: popoverContent, ariaLabel: popoverLabel },
            React__default.createElement("form", { role: "search", onSubmit: onSubmit },
                React__default.createElement(TextInput, __assign({}, textInputProps)))));
    }
    return (React__default.createElement("form", { role: "search", onSubmit: onSubmit },
        React__default.createElement(TextInput, __assign({}, textInputProps))));
});

export { SearchInput as S, SearchIcon as a };
